






























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import CustomerDetail from "@/store/entities/customers/customer-detail";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import { mixins } from "vue-class-component";

@Component
export default class ViewCustomer extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  customer: CustomerDetail = new CustomerDetail();
  spinShow = false;
  code: string = "";
  id: number = 0;
  isClient() {
    return this.$store.state.session.client != null;
  }

  get loading() {
    return this.$store.state.customer.loading;
  }
  async getInfo() {
    await this.$store
      .dispatch({
        type: "customer/getCustomerByKeyword",
        data: {
          keyWord: this.code,
        },
      })
      .then((res) => {
        this.id = res.id;
        this.customer = res;
      });
  }
  cancel() {
    (this.$refs.customerForm as any).resetFields();
    this.$root.$router.push({ name: "customer" });
  }
  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      await this.getInfo();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
